import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 14l-2 -2l2 -2","key":"svg-0"}],["path",{"d":"M14 10l2 2l-2 2","key":"svg-1"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-2"}]]

const IconCodeCircle = createReactComponent('outline', 'code-circle', 'CodeCircle', __iconNode);

export default IconCodeCircle;